import message from './message/zh';
import placeholder from './placeholder/zh';
export default {
  language: {
    name: '中文',
    title: '语言',
  },
  about: {
    title: '泉州市驰尔达电子通讯有限公司',
    conpanyname: '泉州市驰尔达电子通讯有限公司',
    beian: '网站备案号',
    icp: '粤ICP备16086702号',
    copyright: '版权所有：泉州市驰尔达电子通讯有限公司 版本号：v1.4.3 Copyright © 2021-2022'
  },
  login: {

    tag: {
      agent: '代理商',
      company: '单位'
    },

    placeholder: {
      account: '请输入登录账号',
      password: '请输入登录密码'
    },

    button: {
      login: '登录',
      remember: '记住账号？'
    },

    tips: {
      empty: '账号或密码不能为空',
      not_account: '账号不存在',
      err_password: '密码错误',
      completethepuzzle: '拖动下方滑块完成拼图',
      Verificationissuccessful: '验证成功',
      Verificationerrorpleasetryagain: '验证错误，请重试'
    }
  },
  from: {  //表单
    icon: '头像',
    Agent_name: '代理商名称',
    Account: '登录账号',
    Contact_name: '联系人姓名',
    mobile: '手机号',
    uName: '姓名',
    recharge_contact: '续费联系方式',
    Select_Address: '选择地址',
    Detailed_address: '详细地址',
    Not_filled_in: '未填写',
    contact_information: '联系方式',
    area: '地区',
    Reset_Password: '重置密码'
  },
  placeholder: {
    ...placeholder
  },
  message: { //提示
    ...message
  },
  but: {   //按钮
    send_out: '发送',
    preserve: '保存',
    confirm: '确认',
    define: '确定',
    next: '下一步'
  },

  agent: {
    Agency_account: '代理商账户',
    Contact_information: '联系人信息',
    Please_enter_agentname: '请输入代理商名称',
    agentname_required: '（必填：4-20文字、字母、数字）',
    Please_enter_loginAccount: '请输入登录账户',
    loginAccount_required: '（必填：6-20位字母、数字）',
    Please_enter_loginPassword: '请输入登录密码',
    loginPassword_required: '（必填：6-16字母、数字）',
    Please_enter_contactname: '请输入联系人姓名',
    contactname_required: '（必填：2-10文字、字母、数字）',
    Please_enter_address: '请输入代理商详细地址',
    address_optional: '（可选）',
    search_agent: '搜索代理商',
    recover_integer: '收回服务卡数量必须为整数',
    recover_num: '收回数量必须大于0'
  },

  navigation: {
    personal_center: '个人中心',
    search: '搜索',
    my_agent: '我的代理商',
    agent_list: '代理商列表',
    create_agent: '创建代理商',

    my_company: '我的单位',
    company_list: '单位列表',
    create_company: '创建单位',

    my_group: '我的群组',
    group_list: '群组列表',
    create_group: '创建群组',

    my_user: '我的用户',
    user_list: '用户列表',
    create_user: '创建用户',

    news_notice: '消息通知',
    Scanning_code_found: '扫码创建',

    function_card_sell: '服务卡销售',
    function_card_record: '服务卡记录',
    system_annoucement: '系统公告',

    my_bounding: '我的围栏',
    bounding_list: '围栏列表',
    create_bounding: '创建围栏',

    recording_record: '录音记录',
    sos_record: 'SOS记录',
    broadcast_record: '广播记录',
    Agent_details: '代理商详细资料',
    Scancodetocreate: '扫码创建',
    Createuserinformation: '创建用户信息',
    Confirmdetails: '确认详情',
    EditOrganizationInformation: '编辑单位信息',
    notificationreminder: '通知提醒',
    selectgroup: '选择群组',
    edituserinformation: '编辑用户信息',
    Userreplacementcard: '用户补换卡',
    completematerial: '完善资料',
    choosehost: '选择主持人',
    Selectagrouptolistento: '选择要监听的群组',
    Terminalrenewaldetails: '终端续费详情',
    managementplatform: '管理平台',
    electricfence: '电子围栏',
    Electronicfencerecords: '电子围栏记录'
  },

  setup: {
    setup: '设置',
    Change_Password: '重置密码',
    user_information: '个人信息',
    Reset_Login_Password: '重置登录密码',
    Modify_payment_password: '修改支付密码',
    about: '关于',
    Problem_feedback: '问题反馈',
    Verify_phone: '验证手机',
    Set_payment_password: '设置支付密码'
  },

  org: {
    org_name: '单位名称',
    createCompany: '新建单位',
    UnitAccount: '单位账户',
    createGroups: '同时创建16个群组',
    plGroups: '批量群组名称后缀加自然数，重复名称延续自然数'
  },
  consume: '消耗',
  area: '区域',
  logout: '退出登录',
  VerifyPC: 'PC端打开链接',
  connect: '服务器连接异常',
  existing: '现有',
  individual: '个',
  Quantityis: '数量为0，无法收回',
  Withdrawal_quantity: '收回数量不能大于现有数量',
  click_load: '点击加载更多',
  refresh_successfully: '刷新成功',
  search: '搜索',
  detail: '详情',
  edit: '编辑',
  delete: '删除',
  confirm: '确定',
  cancel: '取消',
  call_back: '收回',
  time: '时间',
  category: '类别',
  title: '标题',
  data: '日期',
  starting_date: '开始日期',
  ending_date: '结束日期',
  starting_time: '开始时段',
  ending_time: '结束时段',
  type: '类型',
  please_select: '请选择',
  content: '内容',
  notice: '通知',
  tuneto_agent: '调至代理商',
  beingTransferred_agent: '被调代理商',
  thefence: '围栏',
  member: '成员',
  users: '用户',
  searchuser: '搜索用户',
  group: '群组',
  searchgroup: '搜索群组',
  company: '单位',
  searchunit: '搜索单位',
  agent_name: '代理商',
  prefixnickname: '前缀昵称',
  user_name: '用户名',
  company_name: '所属单位',
  user_info: '用户信息',
  sale: '销售',
  create_user: '创建用户',
  start_service: '开通服务',
  recycle_recycled: '收回/被收回',
  delete_users: '删除用户',
  deletequantity: '删除数量',
  purchasement: '购买',
  change_agents: '调换代理商',
  voice: '语音',
  recording: '录音',
  position: '定位',
  thefence: '围栏',
  video: '视频',
  recycle: '收回',
  recycled: '被收回',
  card_type: '服务卡类型',
  card_type1: '服务卡类型',
  select_card_type: '选择服务卡类型',
  card_number: '服务卡数量',
  ptt_card: '语音卡',
  recording_card: '录音卡',
  gps_card: '定位卡',
  sos_card: 'SOS卡',
  bounding_card: '围栏卡',
  video_card: '视频卡',
  duplex_card: '双工卡',
  vipcard: 'Vip卡',
  ptt_card_sale: '语音卡销售',
  recording_card_sale: '录音卡销售',
  gps_card_sale: '定位卡销售',
  sos_card_sale: 'SOS卡销售',
  bounding_card_sale: '围栏卡销售',
  video_card_sale: '视频卡销售',
  Duplexcardsales: '双工卡销售',
  vipcardsales: 'Vip卡销售',
  usevoicecard: '使用语音卡',
  userecordingcard: '使用录音卡',
  uselocatorcard: '使用定位卡',
  useSOScard: '使用SOS卡',
  usefencecard: '使用围栏卡',
  usevideocard: '使用视频卡',
  Useaduplexcard: '使用双工卡',
  usevipcard: ' 使用Vip卡',
  voiceservicecard: '语音服务卡',
  recordingservicecard: '录音服务卡',
  locationservicecard: '定位服务卡',
  SOSservicecard: 'SOS服务卡',
  fenceservicecard: '围栏服务卡',
  videoservicecard: '视频服务卡',
  Dualservicecard: '双工服务卡',
  vipservicecard: 'Vip服务卡',
  voiceservice: '语音服务',
  recordingservice: '录音服务',
  locationservice: '定位服务',
  SOSservice: 'SOS服务',
  fenceservice: '围栏服务',
  videoservice: '视频服务',
  duplexservice: '双工服务',
  recordingcardrecycling: '录音卡回收',
  LocationCardRecycling: '定位卡回收',
  SOSCardRecycling: 'SOS卡回收',
  FenceCardRecycling: '围栏卡回收',
  videocardrecycling: '视频卡回收',
  Duplexcardrecycling: '双工卡回收',
  VoiceFeatureNotification: '语音功能通知',
  Notificationofrecordingfunction: '录音功能通知',
  Positioningfeaturenotification: '定位功能通知',
  SOSfunctionnotification: 'SOS功能通知',
  Fencefeaturenotification: '围栏功能通知',
  VideoFeatureNotification: '视频功能通知',
  DuplexFeatureNotification: '双工功能通知',
  automatically: '自动删除测试用户通知',
  DeleteExpired: '删除过期用户通知',
  remained: '余额',
  pieces: '张',
  residue: '剩余',
  recycle_successfully: '收回成功',
  None_record: '暂无记录',
  this_month: '本月',
  Year: '年',
  moon: '月',
  day: '日',
  weekly1: '周一',
  weekly2: '周二',
  weekly3: '周三',
  weekly4: '周四',
  weekly5: '周五',
  weekly6: '周六',
  weekly7: '周日',
  submit: '提交',
  modify_successfully: '修改成功',
  confirm1: '确认',
  lumpsum: '总额',
  selltoagents: '销售给代理商',
  nametips: '输入的昵称只是用户昵称的前缀，根据你创建的用户个数以自然数来做后缀区分。例如：您输入的昵称为',
  nametips2: '您创建的两个 用户的昵称分别为',
  nametips3: '下次再以',
  nametips4: '为前缀的昵称，用户名顺延为',
  nametips5: '等',
  IMEIscancodetoadd: 'IMEI扫码添加',
  IMEIinputadded: 'IMEI输入添加',
  IMEIinputaddedtocreate: 'IMEI输入添加最多可创建10个用户',
  Starttherecordingservice: '开启录音服务',
  Turnonlocationservices: '开启定位服务',
  EnableSOSservice: '开启SOS服务',
  Startfenceservice: '开启围栏服务',
  Turnondualservice: '开启双工服务',
  Turnonthevideoservice: '开启视频服务',
  Usercomments: '用户备注',
  Agentnote: '代理商备注',
  total: '合计',
  settlement: '结算',
  hint: '提示',
  Areyousuretoremove: '确认移除吗？',
  Areyousuretoclearall: '确认全部清空吗？',
  cocreated: '共创建',
  accountssubtotal: '个账户，小计',
  Scancodeentryarea: '扫码录入区',
  empty: '清空',
  none: '无',
  Second: '秒',
  Salesvolume: '销售数量',
  Purchasequantity: '购买数量',
  returnquantity: '退回数量',
  Recoveredquantity: '收回数量',
  returnquantity2: '返回数量',
  setasdefaultgroup: '设为默认群组',
  newgroup: '新建群组',
  groupname: '群组名称',
  selected: '已选',
  groups: '个群组',
  allgroups: '全部群组',
  Groupduration: '群组时长',
  calltime: '通话时长',
  groupmembers: '群组成员',
  Modifygroupname: '修改群组名称',
  priority: '优先级',
  remove: '移除',
  addmembers: '添加成员',
  levelone: '一级',
  Secondary: '二级',
  Levelthree: '三级',
  Levelfour: '四级',
  Fifthgrade: '五级',
  OKtoadd: '确定添加',
  reenter: '重新输入',
  Setdigitservicecardpassword: '设置6位服务卡密码',
  Enteragaintoconfirm: '再输入以确认',
  Enterthedigitservicecardpassword: '输入6位服务卡密码',
  consumptioncard: '消耗定位卡',
  ConsumeSOScard: '消耗SOS卡',
  Consumefencecard: '消耗围栏卡',
  Consumptionrecordingcard: '消耗录音卡',
  Consumeduplexcard: '消耗双工卡',
  Consumptionvideocard: '消耗视频卡',
  account: '账号',
  unfilled: '未填写',
  contactnumber: '联系电话',
  emailaddress: '邮箱地址',
  mailingaddress: '通讯地址',
  Belonginggroup: '所属群组',
  Nickname: '昵称',
  suspendaccount: '账号',
  unitdispatcher: '单位调度员',
  dispatcher: '调度员',
  basestationpositioning: '基站定位',
  GPSlocation: 'GPS定位',
  positioninginterval: '定位间隔',
  videocall: '视频呼叫',
  strongpullvideo: '强拉视频',
  videoreturn: '视频回传',
  Numberchangeperiod: '换号期限',
  UsersNickname: "用户昵称",
  volumeactivation: '批量激活',
  batchselection: '批量选择',
  searchhistory: '搜索历史记录',
  returnnotice: '返回通知',
  Notificationofbeingwithdrawn: '被收回通知',
  takebacknotice: '收回通知',
  bouncenotification: '退回通知',
  Notificationofbeingreturned: '被退回通知',
  Createusernotification: '创建用户通知',
  purchasenotice: '购买通知',
  salereminder: '销售提醒',
  today: '今天',
  yesterday: '昨天',
  thedaybeforeyesterday: '前天',
  OriginalIMEI: '原IMEI',
  NewIMEI: '新IMEI',
  replace: '更换',
  verificationcode: '验证码',
  resendverificationcode: '重发验证码',
  back: '后',
  host: '主持人',
  listeninggroup: '监听群组',
  Addlisteninggroup: '添加监听群组',
  Nodata: '暂无数据',
  Corenewal: '共续费',
  Accountssubtotal: '个账户，小计',
  Confirmrenewal: '确认续费',
  add_groupname_tips: '批量群组名称后缀加自然数，重复名称延续自然数',
  Dataloadingcomplete: '数据加载完成',
  Usercreatedgroups: '用户自建组',
  Lord: '群主',
  chooseagroupleader: '选择群主',
  alluser: '全部用户',
  SOSalarmsintemporarygroupsarenotrecorded: '临时群组中的SOS告警不做记录',
  username: '用户名称',
  startingtime: '发起时间',
  Processor: '处理人',
  processtime: '处理时间',
  Unprocessed: '未处理',
  Processed: '已处理',
  deleted: '已删除',
  name: '名称',
  address: '地址',
  Warmreminder: '温馨提示：数据来源第三方，会存在误差，仅供参考',
  SOSlocation: 'SOS位置',
  permanent: '永久',
  Latitudeandlongitude: '经纬度',
  Reportingtime: '上报时间',
  Positioningtime: '定位时间',
  op1: '开启',
  op2: '关闭',
  groupban: '群组禁言',
  Sun: '日',
  Mon: '一',
  Tue: '二',
  Wed: '三',
  Thu: '四',
  Fri: '五',
  Sat: '六',
  Membermanagement: '成员管理',
  Validpermanently: '永久有效',
  Enteralarm: '进入告警',
  Leavealarm: '离开报警',
  repeat: '重复',
  Updatefence: '更新围栏',
  Triggermode: '触发方式',
  Validperiod: '有效时段',
  start: '开始',
  end: '结束',
  Validdate: '有效日期',
  fencekeeper: '围栏管理员',
  Membermanagement: '成员管理',
  fencename: '围栏名称',
  Editfence: '编辑围栏',
  Setupafencemanager: '设置围栏管理员',
  Fencedetails: '围栏详情',
  Currentoutofboundsrecord: '当前越界记录',
  Historicalcrossborderrecords: '历史越界记录',
  Allfences: '全部围栏',
  Triggertime: '触发时间',
  Releasetime: '解除时间',
  NoExit: '禁出',
  NoEntry: '禁入',
  Recordinglist: '录音列表',
  temporarygroup: '临时群组',
  Determinethereplacement: '确定更换',
  Regionalreplacement: '区域更换',
  Recoverypassword: '恢复密码',
  usertype: '用户类型',
  Singlefunctioncarduser: '单功能卡用户',
  vipcarduser: 'Vip卡用户'
}
